"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerService = void 0;
const getters_1 = require("../../functions/external/getters");
const events_1 = require("../../constants/internal/events");
const events_2 = require("../../enums/external/events");
class ServerService {
    socket;
    constructor(socket) {
        this.socket = socket;
        events_1.SOCKET_BROADCAST_EVENTS.forEach((event) => {
            this[event] = this.generateBroadcastEvent(event).bind(this);
        });
    }
    log(message) {
        console.log(`[SOCKET][#${this.socket.id}][${this.userName}]: ${message}`);
    }
    get userName() {
        return this.socket.data.username ?? this.socket.data.userId ?? 'Anonymous';
    }
    send(event, data) {
        const room = (0, getters_1.getRoomName)(data.target, this.socket.data.userId);
        this.socket.broadcast.to(room).emit(event, data);
        this.log(`User (${this.userName}) send ${event} message to room ${room}`);
    }
    generateBroadcastEvent(event) {
        return (data) => {
            this.send(event, data);
        };
    }
    [events_2.SocketEvent.AUTH](data) {
        const { userId, username } = data;
        this.socket.data.userId = userId;
        this.socket.data.username = username;
        this.log(`User (${this.userName}) connected to server`);
    }
    [events_2.SocketEvent.JOIN](data) {
        const room = (0, getters_1.getRoomName)(data.target, this.socket.data.userId);
        this.socket.join(room);
        this.socket.broadcast.to(room).emit(events_2.SocketEvent.JOINED, this.socket.data);
        this.log(`User (${this.userName}) has been joined to the room ${room}`);
    }
    [events_2.SocketEvent.LEAVE](data) {
        const room = (0, getters_1.getRoomName)(data.target, this.socket.data.userId);
        this.socket.leave(room);
        this.log(`User (${this.userName}) has been leaved the room ${room}`);
    }
    [events_2.SocketEvent.DISCONNECT]() {
        this.log(`User (${this.userName}) disconnected from the server`);
    }
    [events_2.SocketEvent.CONNECT_ERROR](error) {
        this.log(`Connect Error: ${error}`);
    }
    [events_2.SocketEvent.CONNECT_FAILED](error) {
        this.log(`Connect Failed: ${error}`);
    }
    static create(socket) {
        return new this(socket);
    }
}
exports.ServerService = ServerService;
